<template lang="html">

    <div>

		<!-- page-heading -->
		<page-heading :pageTitle="pageTitle"></page-heading>

		<div class="columns" v-if="!isLoading">

			<div class="col-main">

                <div class="box">

                    <form-input inputType="text" v-model="productGroup.name" label="PIM-PRODUCT_GROUP-NAME"></form-input>
                    <form-input inputType="textarea" v-model="productGroup.description" label="PIM-PRODUCT_GROUP-DESCRIPTION"></form-input>

                    <div class="divider"></div>

                    <custom-button style="margin: 0 0 25px 0;" icon="icon-ak-hinzufuegen" name="PIM-PRODUCT_GROUP-BTN-ADD_PRODUCTS" type="white" size="small" @click.native="productsAdd"></custom-button>

                    <v-client-table
                        ref="pimProductGroupsTable"
                        name="pimProductGroupsTable"
                        class="pimTable"
                        :data="products"
                        :columns="table.tblColumns"
                        :options="table.tblOptions">

                        <!-- image -->
                        <template slot="image" slot-scope="props">
                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + props.row.image" :key="props.row.id"></div>
                        </template>

                        <!-- price -->
                        <template slot="price" slot-scope="props">
                            {{ formatPoint2Comma(props.row.price) }}
                        </template>

                        <!-- category -->
                        <template slot="category" slot-scope="props">
                            {{ props.row.categoryPath }}
                        </template>

                        <!-- size -->
                        <template slot="size" slot-scope="props">
                            {{ props.row.packagingSize }}
                        </template>

                        <!-- manufacturer -->
                        <template slot="manufacturer" slot-scope="props">
                            {{ props.row.manufacturerName }}
                        </template>

                        <template slot="actions" slot-scope="props">

                            <pop-confirm
                                class="button is-small"
                                content="Soll dieses Produkt aus der Gruppe entfernt werden?"
                                icon="question-circle-o"
                                :on-ok="function() { productDelete(props.row.id) }"
                                cancel-text="nein">

                                <span class="icon is-small" title="Produkt löschen">
                                    <i class="icon-ak-entfernen"></i>
                                </span>

                            </pop-confirm>

                        </template>

                    </v-client-table>
                </div>

            </div>

            <div class="col-aside">

                <affix :offset="50">

                    <custom-button :loading="isSaving" icon="icon-ak-speichern" name="PIM-PRODUCT_GROUP-BTN-SAVE" type="blue" @click.native="save"></custom-button>

                </affix>

            </div>

        </div>


        <modal
            title="Produkte"
            transition="fadeDown"
            :is-show="showModal"
            :backdrop-closable="false"
            :show-footer="true"
            @close="closeModal"
            class="vcenter productGroupModal">

                <pim-products
                    v-if="showModal"
                    :showPagination="false"
                    :allowDelete="false"
                    :allowSelection="true"
                    :allowEditName="false"
                    :showPharmacyFilter="false"
                    :showFilters = "['filterPackageLeaflet', 'filterCategory', 'filterMultiple', 'filterVariableProduct', 'filterIsDrug', 'filterImage']"
                    :preselectedProducts="preselectedProducts"
                    @selectedRows="selectProducts">
                </pim-products>

                <template slot="footer">
                    <a class="button" @click.prevent.parent="closeModal">Abbrechen</a>
                    <a :class="['button is-primary', { 'is-disabled': selectedProducts == null || selectedProducts.length == 0 }]" @click.prevent.parent="assignProducts">Übernehmen</a>
                </template>

        </modal>

    </div>

</template>

<script>
import Vue from 'vue';

import { ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import pimProducts from './incl-pimProducts';

export default {

    components: {
        pimProducts,
    },

    data () {
        return {

            isLoading: false,
            isSaving: false,
            productGroup: null,

            selectedProducts: [],
            products: [],
            showModal: false,

            table: {

                tblOptions: {
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,

                    orderBy: {
                        ascending: false,
                        column: 'extRef'
                    },

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    resizableColumns: true,

                    headings: {

                        image(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-IMAGE"></lang>
                        },
                        extRef(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-EXTREF"></lang>
                        },
                        name(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-NAME"></lang>
                        },
                        category(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-CATGORY"></lang>
                        },
                        price(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-PRICE"></lang>
                        },
                        size(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-SIZE"></lang>
                        },
                        manufacturer(h) {
                            return <lang labelKey="PIM-PRODUCT_GROUP-TABLE_HEADING-MANUFACTURER"></lang>
                        },
                        actions(h) {
                            return "";
                        },
                    },

                    // sortable: ['type', 'source', 'status', 'validFrom', 'validTo', 'status', 'productsCount', 'voucherCode'],

                    texts: {
                        first:'Anfang',
                        last:'Ende',
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
                        loading: 'Lade Daten ...'
                    },

                    pagination: {
                        dropdown: false,
                        chunk: 5,
                        edge: false
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [

                    ],

                    filterable: false,

                    columnsClasses: {
                        'actions': 'actions',
                        'image': 'thumbnail',
                        'price': 'price',
                        'extRef': 'pzn',
                        'manufacturer': 'brand',
                        'size': 'packagingSize',
                    },
                },

                tblColumns: ['image', 'extRef', 'name', 'category', 'price', 'size', 'manufacturer', 'actions'],
            },
        }
    },

    created() {

        if(this.$route.name == 'pimProductGroupsNew') {

            this.productGroup = {
                name: '',
                extRef: '',
                site: this.siteId,
                products: []
            }

        } else {

            console.log("id: ", this.$route.params.id);

            this.fetchData(this.$route.params.id);

        }


    },

    computed: {

        pageTitle() {
            return this.productGroup != null && typeof this.productGroup.name != 'undefined' && this.productGroup.name != '' && this.productGroup.name != null
                ? this.productGroup.name
                : 'PIM-PRODUCT_GROUP-HEADER';
        },

        preselectedProducts() {

            /*
            return typeof this.productGroup.products != 'undefined' && this.productGroup.products.length > 0
                ? this.productGroup.products.map(_ => parseInt(_.id))
                : []
            */

            return this.products.length > 0
                ? this.products.map(_ => parseInt(_.id))
                : []

        },

        siteId() {

            return this.activeUser.site == null ? null : this.activeUser.site.id;

        }

    },

    methods: {

        closeModal() {

            this.showModal = false;

        },


        selectProducts(products) {

            this.selectedProducts = products;

        },

        /*
        assignProducts() {

            if(typeof this.productGroup.id == 'undefined') {

                this.axios.post(this.$config.api + 'pimProductGroup', this.productGroup).then(res => {

                    this.$set(this.productGroup, 'id', res.data.id);
                    this._assignProducts();

                })

            } else {

                this._assignProducts();

            }

        },

        _assignProducts() {

            this.selectedProducts.forEach(p => {
                this.productGroup.products.push({
                    pimProduct: p,
                    pimProductGroup: this.productGroup.id
                });
            })

            this.closeModal();

        },
        */
        assignProducts() {

            this.products.push(...this.selectedProducts);

            this.$forceUpdate();
            this.closeModal();

        },

        productsAdd() {

            this.showModal = true;

        },

        productDelete(id) {

            let index = this.products.findIndex(p => p.id == id);
            if(index > -1) {
                this.products.splice(index, 1);
            }

        },

        save() {

            this.isSaving = true;

            let method, url, msg;

            if(typeof this.productGroup.id != 'undefined') {
                method = "put";
                url = "apopointProductGroup/"+this.productGroup.id;
                msg = "Erfolgreich gespeichert!";
            } else {
                method = "post";
                url = "apopointProductGroup";
                msg = "Produkt-Gruppe wurde erfolgreich angelegt!";
            }

            if(this.products.length > 0) {

                this.productGroup.products = [];
                this.products.forEach(p => {

                    this.productGroup.products.push({
                        pimProduct: p.id,
                        productGroup: this.productGroup.id
                    });

                })

            } else {

                this.productGroup.products = [];
            }

            this.axios[method](this.$config.api + url, this.productGroup).then(res => {
                this.$notify.open({ content: msg, type: 'success'});
                this.isSaving = false;
            });

        },


        fetchData(id) {

            this.isLoading = true;

            this.axios.get(this.$config.api + 'apopointProductGroup/'+id+'?include=apopointProductGroup.products,apopointProductGroupProduct.pimProduct').then(res => {

                this.productGroup = res.data;

                if(res.data.products.length > 0) {
                    res.data.products.forEach(p => {
                        this.products.push(p.pimProduct)
                    })
                }

                this.isLoading = false;

            })


        }
    }

}
</script>

<style lang="scss" scoped>

    .divider {
        padding-top: 20px;
        margin-bottom: 15px;
        border-bottom: 2px solid #F5F7F9;
    }

    .productGroupModal {

        ::v-deep .modal-card {
            min-width: 640px;
            max-width: 90%;
            width: 100%;
            max-height: 95vh;
            overflow: hidden;
        }

    }

    .pimTable {

        ::v-deep .VueTables__table {

            td.thumbnail {
                width: 120px;
                max-width: 120px;

                .imgWrapper {
                    background-repeat: no-repeat;
                    background-position: 50% 50%;
                    background-size: contain;
                    width: 80px;
                    height: 60px;
                    margin: 0;
                    background-color: #FFF;
                    border: 1px solid #efefef;
                    border-radius: 2px;
                }
                .imgWrapper[lazy=loading]  {
                    background-size: 30% !important;
                }
                .imgWrapper[lazy=error]  {
                    background-image: none !important;
                }

            }
            td.pzn {
                width: 120px;
                max-width: 120px;
            }
            td.packagingSize {
                width: 180px;
                max-width: 180px;
            }
            td.price {
                width: 120px;
                max-width: 120px;
            }
            td.brand {
                width: 180px;
                max-width: 180px;
            }

            td.actions {

                text-align: right;

                .button {
                    .icon {
                        margin: 0 !important;
                        font-size: 12px;
                    }
                }

            }
        }

    }


</style>
